import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { ListItem, MaterialLocationQuantity, RepositoryModal } from '../../shared'
import { MaterialLocationQuantitiesComponent } from './material-location-quantities.component'

@Component({
    templateUrl: './material-location-quantity.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class MaterialLocationQuantityComponent extends RepositoryModal<MaterialLocationQuantity> {
    materialOptions: ListItem<string>[] = []
    locationOptions: ListItem<string>[] = []

    protected onInitialized() {
        const parentController = this.editOptions.initializeParams as MaterialLocationQuantitiesComponent
        this.materialOptions = parentController.rawMaterials.map(x => new ListItem(x.barcode, x.name))
        this.locationOptions = parentController.rawLocations.map(x => new ListItem(x.key, x.value))
    }

    onBeforeSave() {
        if (!this.target.material || !this.target.location || this.target.quantity == undefined) {
            this.services.notification.warning('Please fill in all fields.')
            return false
        }
        return true
    }
}
